var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMotorpointCircleLogo = function SvgMotorpointCircleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25z",
    fill: "#D64309"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46.003c11.6 0 21.003-9.403 21.003-21.003 0-11.599-9.404-21.002-21.003-21.002C13.4 3.998 3.998 13.401 3.998 25 3.998 36.6 13.4 46.004 25 46.004z",
    fill: "#004996"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.102 29.144v-6.286c0-4.7-3.505-8.075-7.785-8.075h-.79c-2.17 0-4.14.989-5.556 2.575-1.415-1.586-3.385-2.575-5.554-2.575h-.79c-4.283 0-7.786 3.845-7.786 8.545v9.625h4.038v-8.075c0-2.018 0-6.056 4.037-6.056s4.037 4.038 4.037 6.056v8.075h4.037v-8.075c0-1.669 0-6.056 4.037-6.056 4.038 0 4.038 4.387 4.038 6.056v4.266h4.037z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.084 34.97a2.019 2.019 0 1 0 0-4.036 2.019 2.019 0 0 0 0 4.037z",
    fill: "#D64309"
  })));
};
export default SvgMotorpointCircleLogo;